import { EventEmitter, Injectable, OnInit, Output } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";

@Injectable()
export abstract class CrudForm<T> implements OnInit {
  public form: FormGroup;
  public mode: "stanby" | "create" | "update" = "stanby";
  public defaults?: T = undefined;
  public waiting: boolean = false;
  @Output() onsave = new EventEmitter<{ mode: string; value: T }>();
  constructor(protected fb: FormBuilder) {}

  public ngOnInit() {
    this.buildForm();
  }
  public setStanby() {
    this.mode = "stanby";
    this.defaults = undefined;
    this.form.reset();
  }
  public setCreate() {
    this.mode = "create";
    this.defaults = undefined;
    this.form.reset();
  }
  public setUpdate(row: T) {
    this.mode = "update";
    this.defaults = row;
    this.fromInit(row);
  }
  public save() {
    if (this.mode === "create") this.create();
    else if (this.mode === "update") this.update();
  }

  public create() {
    this.onsave.emit({ mode: this.mode, value: this.form.value });
  }

  public update() {
    this.onsave.emit({ mode: this.mode, value: this.form.value });
  }

  public isCreateMode() {
    return this.mode === "create";
  }

  public isUpdateMode() {
    return this.mode === "update";
  }

  // PARA SER SOBREESCRITOS
  protected buildForm() {}

  protected fromInit(row: T) {}
  public setWaiting(value: boolean) {
    this.waiting = value;
  }
}
